import * as React from "react";

import { useTranslation } from "react-i18next";

import {cn} from "../../../utils/cn";
import { Label } from "./label";
type FieldWrapperProps = {
  label: string;
  className?: string;
  children: React.ReactNode;
  htmlFor?: string;
  error?: string | undefined;
  isRequired?: boolean;
};

export type FieldWrapperPassThroughProps = Omit<
  FieldWrapperProps,
  "className" | "children"
>;

export const FieldWrapper = (props: FieldWrapperProps) => {
    const {t} = useTranslation();
    const { label, children, htmlFor, className, isRequired } = props;
    return (
        <div className={cn("form-block", className)}>
            {/* Add label component */}
            <Label label={t(`common:fields.${label}`)} htmlFor={htmlFor} className={isRequired ? "required" : ""} />
            {children}
        </div>
    )
}